<div class="info-message-container-holder">
  <div class="info-message-container">
    <div *ngIf="icon" class="info-message-icon">
      <i class="{{ 'fa ' + icon + ' fa-3x' }}" [ngStyle]="{ color: color }"></i>
    </div>
    <div class="info-message-body" [innerHTML]="safeHtml"></div>

    <div
      class="info-message-footer"
      *ngIf="showButton"
      [ngStyle]="{ backgroundColor: color }"
    >
      <ion-button
        fill="clear"
        [ngStyle]="{ '--color': buttonTextColor }"
        expand="full"
        (click)="validated.emit(true)"
      >
        {{ buttonLabel }}
      </ion-button>
    </div>
  </div>
</div>
